<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <layouts></layouts>
    <sidebar-menu></sidebar-menu>
    <div class="page-wrapper">
      <div class="content">
        <pageheader :title="title + ' - ' + namaCompany" :title1="title1" />

        <!-- /add -->
        <div class="card">
          <div class="card-body">
            <!-- <Form @submit="update" :validation-schema="schema" v-slot="{ errors }"> -->
            <form @submit.prevent="insert">
              <pageheader title="Employee Data" title1="" />

              <div class="row">
                <div class="col-12 mb-3">
                  <embed :src="googleMap" type="" id="lokasi" class="w-100 h-100 pe-4 rounded">
                </div>
                <div class="col-lg-3 col-sm-6 col-12">
                  <div class="form-group">
                    <label>Location Name <span class="text-danger">*</span></label>
                    <input type="text" v-model="currentData.nama_lokasi" placeholder="" required />
                  </div>
                </div>
                <div class="col-lg-3 col-sm-6 col-12">
                  <div class="form-group">
                    <label>Location Code <span class="text-danger">*</span></label>
                    <input type="text" v-model="currentData.kode_lokasi" placeholder="" required />
                  </div>
                </div>
                <div class="col-lg-3 col-sm-6 col-12">
                  <div class="form-group">
                    <label>Lat <span class="text-danger">*</span></label>
                    <input type="text" v-model="currentData.lat" placeholder="" required />
                  </div>
                </div>
                <div class="col-lg-3 col-sm-6 col-12">
                  <div class="form-group">
                    <label>Long <span class="text-danger">*</span></label>
                    <input type="text" v-model="currentData.lng" placeholder="" required />
                  </div>
                </div>
                <div class="col-lg-12 mb-3">
                  <div class="d-flex justify-content-end">
                    <button type="button" class="btn btn-primary" @click="cekGoogleMap">Cek</button>
                  </div>
                </div>

                <div class="col-lg-12">
                  <div class="form-group">
                    <label>Address</label>
                    <textarea class="form-control" v-model="currentData.alamat">
                    </textarea>
                  </div>

                  <div class="form-group">
                    <label>UMR</label>
                    <input type="text" v-model="currentData.umr" @input="formatCurrency(currentData.umr)" placeholder="Rp. 0">
                  </div>

                </div>

                <div class="col-lg-12">
                  <button type="submit" class="btn btn-submit me-2">Insert</button>
                  <router-link to="location" class="btn btn-cancel">Cancel</router-link>
                </div>
              </div>

            </form>
          </div>
        </div>
        <!-- /add -->
      </div>
    </div>
  </div>
</template>
<script>
import Cookies from "js-cookie";
import axios from "axios";
import { base_url, AlertPopup2, goPage, AlertBottom, appendForm, timeout, selectedBranch, rupiahInput, rupiahoutput } from "@/assets/js/function";


export default {
  
  name: "editemployee",
  data() {
    return {
      filter: true,
      title: "Insert Location",
      title1: "add new location",
      namaCompany: '',
      config: "",
      api: "",
      foto_ktp_img: "",
      googleMap: "",

      //data
      currentData: {
        alamat: "",
        nama_lokasi: "",
        kode_lokasi: "",
        lat: "0",
        lng: "0",
      },
      currentDate: new Date,
    };
  },

  created() {
    const token = Cookies.get("token_refresh");
    this.config = {
      headers: {
        Authorization: `Bearer ` + token,
      },
      timeout: 30000,
    }
    
    const branch = parseInt(localStorage.getItem("selectedBranch")) || 0;

    //Update local and shared state
    this.filter = branch;
    selectedBranch.value = branch;

    localStorage.setItem('actionState', 'insert')

    this.namaCompany = localStorage.getItem('namaCompany');

    this.googleMap = 'https://maps.google.com/maps?q=1,1&output=embed';

  },
  
  methods: {

    formatCurrency(number, index) {
      this.currentData.umr = rupiahInput(number);
    },
    

    async insert() {
      
      const formData = new FormData();
      appendForm(formData)

      Object.entries(this.currentData).forEach(([key, value]) => {
        formData.append(key, value);
      });

      //set to indonesia again to save
      formData.delete("lat");
      formData.delete("lng");

      // formData.append('latlng', this.currentData.lat + "," + this.currentData.lng);
      formData.append('lat', this.currentData.lat);
      formData.append('lng', this.currentData.lng);

      formData.append('umr', this.currentData.umr ? rupiahoutput(this.currentData.umr) : '');



      // for (let [key, value] of formData.entries()) {
      //   console.log(`${key}: ${value}`);
      // }
      // return true;

      const api = base_url + '/v3/location/insert';
      const res = await axios.post(api, formData, { timeout });
      const data = res.data;

      if(data.status){
          AlertBottom(data.message);
          goPage("location");
          
          
      }else {
          AlertPopup2("error", "", data.message, true, 1500);
      }

      
    },

    cekGoogleMap() {
     
      this.googleMap = 'https://maps.google.com/maps?q=' + this.currentData.lat + ',' + this.currentData.lng + '&output=embed';
   
    }

  },

};
</script>
